import actions from './actions'

export default function MouseActivitysReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_MOUSEACTIVITY:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_MOUSEACTIVITY:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_MOUSEACTIVITY:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_MOUSEACTIVITY:
      return {
        ...state,
        editing: { mouseActivityID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_MOUSEACTIVITY_RECIEVED ||
      actions.UPDATE_MOUSEACTIVITY_RECIEVED ||
      actions.DELETE_MOUSEACTIVITY_RECIEVED:
      return {
        ...state,
        editing: { mouseActivityID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
